module.exports = __webpack_public_path__ + "img/absorbente7.089b1622.jpg";